const toggleDisableClass = (element, isDisabled) => {
  element.classList.toggle('is-disabled', isDisabled);
};

const addRemoveCounterButton = (element, isIncrement) => {
  const parentElem = element.closest('.counter');
  const inputElem = parentElem.querySelector('.counter__input');
  const minusButton = parentElem.querySelector('.counter__button--remove');
  let currentVal = parseInt(inputElem.value, 10);

  // Retrieve the minimum value from the data attribute, defaulting to 0 if not present
  const minValue = parseInt(inputElem.getAttribute('data-min') || '0', 10);

  if (isIncrement || currentVal > minValue) {
    currentVal = isIncrement ? currentVal + 1 : currentVal - 1;
    inputElem.value = currentVal;
    toggleDisableClass(minusButton, currentVal <= minValue);
  }

  if (parentElem.classList.contains('counter--child')) {
    const childContainer = parentElem.querySelector('.child-counter__inputs');
    const placeholder = parentElem.getAttribute('data-placeholder');
    const required = parentElem.getAttribute('data-required') === 'true'; // Dynamic check
    const errorMsg = parentElem.getAttribute('data-error-message'); // Dynamic error message

    if (isIncrement) {
      const childId = `child-${currentVal}`;

      // Create the dropdown HTML structure and conditionally add `required` and `errorMsg`
      const dropdownHtml = `
        <div data-component="at-dropdown" class="dropdown" id="${childId}">
          <div class="dropdown__placeholder">
            <span class="dropdown__placeholder-text">${placeholder} ${currentVal}</span>
            <i data-component="at-icon" class="icon icon-chevron-down"></i>
          </div>
          <div class="dropdown__list">
            <ul class="dropdown__list-inner" data-radio-parent="">
              ${[...Array(12)]
                .map(
                  (_, index) => `
                <li class="dropdown__list-item">
                  <input type="radio" name="child-${currentVal}" data-fv-name="child-${currentVal}" value="${
                    index + 1
                  }" id="item_${currentVal}_${index + 1}"
                    ${required ? 'required' : ''}
                    ${errorMsg ? `data-fv-not-empty___message="${errorMsg}"` : ''}>
                  <label for="item_${currentVal}_${index + 1}" class="dropdown__list-option text--12">
                    ${index + 1}
                  </label>
                </li>
              `,
                )
                .join('')}
            </ul>
          </div>
        </div>
      `;

      childContainer.insertAdjacentHTML('beforeend', dropdownHtml);
    } else {
      // Remove the dropdown when decrementing
      const dropdownToRemove = document.getElementById(`child-${currentVal + 1}`);
      if (dropdownToRemove) {
        childContainer.removeChild(dropdownToRemove);
      }
    }
  }
};

attachEvent('.counter__button--add', 'click', (ev) => {
  addRemoveCounterButton(ev.target, true);
});

attachEvent('.counter__button--remove', 'click', (ev) => {
  addRemoveCounterButton(ev.target, false);
});

// ********
// Counter Disabled Class
// ********
const initCounters = () => {
  const counterEle = document.querySelectorAll('.counter');
  counterEle.forEach((el) => {
    const inputElem = el.querySelector('.counter__input');
    const minusButton = el.querySelector('.counter__button--remove');
    const currentVal = parseInt(inputElem.value, 10);

    // Retrieve the minimum value from the data attribute, defaulting to 0 if not present
    const minValue = parseInt(inputElem.getAttribute('data-min') || '0', 10);

    toggleDisableClass(minusButton, currentVal <= minValue);
  });
};

initCounters();
